import React, { Component } from "react";

class QChoice2 extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = {
      value: "",
      show_next: false
    };
  }

  componentDidMount() {
    if (this.props.show_focus) setTimeout(() => this._input.focus(), 1000);
    if (this.props.accessor) {
      let { value = "" } = this.props.accessor(this.props.answers);
      if (value && typeof value !== "boolean") value = parseInt(value);
      this.setState({
        value,
        show_next: this.props.possible_answers.includes(value)
      });
    } else if (this.props.answers[this.props.index]) {
      let { value = "" } = this.props.answers[this.props.index];
      if (value && typeof value !== "boolean") value = parseInt(value);
      this.setState({
        value,
        show_next: this.props.possible_answers.includes(value)
      });
    }
  }

  onKeyPress = e => {
    if (e.keyCode === 13) {
      this.props.handle_next();
    }
  };

  answer = value => () => {
    this.props.callback(value);
    this.props.handle_next();
  };

  render() {
    return (
      <div>
        {this.props.title ? (
          <div className="label2 bold">{this.props.title.toUpperCase()}</div>
        ) : null}
        <div className="label">{this.props.text}</div>
        <div className="margin-t-20">
          {this.props.label.map(l => (
            <div className="label2">{l}</div>
          ))}
        </div>

        {this.props.vert ? (
          <div className="margin20 ">
            <div>
              <button
                className={`button ${
                  this.state.value === this.props.possible_answers[0]
                    ? "focused"
                    : ""
                }`}
                onClick={this.answer(this.props.possible_answers[0])}
                style={{ width: this.props.button_width }}
              >
                {this.props.choices[0]}
              </button>
            </div>
            <div className="or_text">or</div>
            <div>
              <button
                className={`button ${
                  this.state.value === this.props.possible_answers[1]
                    ? "focused"
                    : ""
                }`}
                onClick={this.answer(this.props.possible_answers[1])}
                style={{ width: this.props.button_width }}
              >
                {this.props.choices[1]}
              </button>
            </div>
          </div>
        ) : (
          <div className="margin20">
            <div>
              <button
                className={`button margin20 margin-w-10 ${
                  this.state.value === this.props.possible_answers[0]
                    ? "focused"
                    : ""
                }`}
                onClick={this.answer(this.props.possible_answers[0])}
                style={{ width: this.props.button_width }}
              >
                {this.props.choices[0]}
              </button>

              <button
                className={`button margin20 margin-w-10 ${
                  this.state.value === this.props.possible_answers[1]
                    ? "focused"
                    : ""
                }`}
                onClick={this.answer(this.props.possible_answers[1])}
                style={{ width: this.props.button_width }}
              >
                {this.props.choices[1]}
              </button>
            </div>
          </div>
        )}

        {this.state.show_next ? (
          <div className="button-wrap">
            <button className="button" onClick={this.props.handle_next}>
              NEXT
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}

export default QChoice2;
